export default __webpack_public_path__ + "static/media/padlock-image.bcb9e916.webp";